import { render } from "./index.vue?vue&type=template&id=48a789fa&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=48a789fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a789fa"]])

export default __exports__